import axios from "axios";

const Base_Url=process.env.REACT_APP_BASE_URl;
const Api_Url = `${process.env.REACT_APP_API_URL}/api`;


export const PartenerSheepDeedService={

    partenerShipDeedForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addData`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },

    pvtLtdCompanyRegistionForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addPvtcompanyregistion`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },
    opcCompanyRegistionForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addopccompanyregistion`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },
    sectionEightRegistionForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addsetioneightcompanyregistion`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },
    llpRegistionForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addllpcompanyregistion`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },
    annualComplainForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addannulcomplains`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },

    annualComplainPvtLtdForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addannulcomplainspvtltd`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },
   
    // contact

    contactForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addContactForm`,prData);
            console.log(response);
            return response.data;
        }
        catch(error){
            console.log(error);
           throw error;
        }
  
    },
    // registration

    IECForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addIECRegistration`,prData);
            console.log(response);
            return response.data;
        }
        catch(error){
            console.log(error);
           throw error;
        }
  
    }, 
    msmeForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addMSMERegistration`,prData);
            console.log(response);
            return response.data;
        }
        catch(error){
            console.log(error);
           throw error;
        }
  
    },
    gumstaLincesForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addGumstaLincesRegistration`,prData);
            console.log(response);
            return response.data;
        }
        catch(error){
            console.log(error);
           throw error;
        }
  
    },

    trademarkLincesForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addTrademarkRegistration`,prData);
            console.log(response);
            return response.data;
        }
        catch(error){
            console.log(error);
           throw error;
        }
  
    },
    
    gstRegistraionForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addGstRegistration`,prData);
            console.log(response);
            return response.data;
        }
        catch(error){
            console.log(error);
           throw error;
        }
  
    },
      
    foodLincenceForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addFoodlicenceRegistration`,prData);
            console.log(response);
            return response.data;
        }
        catch(error){
            console.log(error);
           throw error;
        }
  
    },
// filing 

    gstReturnForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addgstreturan`,prData);
            console.log(response);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },
    
    itrFilingForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/additerfilings`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },

    tdsReturnForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addTdsRegistration`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },
   onlineAccountingForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addonlineaccounting`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },

    // legal issues
    
   legalNoticeReplyForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addLegalNoticeReplay`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },
   legalNoticeForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addLegalNoticePreparation`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },
   legalAdviceForm:async(prData)=>{
        try{
            const response=await axios.post(`${Base_Url}/addLegaladviceRegistration`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
  
    },

//  New Added


       societyForm:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-society-registration`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },


       cmaReport:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-cma-report`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },

    
       professionalTaxForm:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-professional-tax`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },

       balanceSheetPL:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-balance-sheet-pl`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },

       Dissolution:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-dissolution-of-deeds`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },

       addressAmendmentLLP:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-address-amendment-llp`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },

       addressAmendmentCompany:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-address-amendment-company`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       addressAmendmentOutOfStateCompany:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-address-amendment-outofstate-company`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },

       addressAmendmentOutOfStateLLP:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-address-amendment-outofstate-llp`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       addDirectorCompany:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-add-director-company`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       addPartnerCompany:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-add-partner-company`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       increaseCapitalCompany:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-increase-capital-company`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       increaseCapitalLLP:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-increase-capital-llp`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       changeNameLLP:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-change-name-llp`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       changeNameCompany:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-change-name-company`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       removeDirectorCompany:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-remove-director-company`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       removePartnerLLP:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-remove-partner-llp`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       pfAndEsicRegistration:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-pf-and-esic-registration`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       drafting:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-drafting`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },
       pfEsicReturn:async(prData)=>{
        try{
            const response=await axios.post(`${Api_Url}/add-pfesicreturn`,prData);
            return response.data;
        }
        catch(error){
           throw error;
        }
    },



















}